import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.1.1?node-id=9410%3A25426
 *
 * @param {SvgIconProps} props - svg props
 */
export const DeclineButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path d='M15.9418 8.88043C16.0199 8.80232 16.0199 8.67569 15.9418 8.59758L15.4021 8.05792C15.324 7.97982 15.1974 7.97982 15.1192 8.05793L11.9998 11.1773L8.88043 8.05793C8.80232 7.97982 8.67569 7.97982 8.59758 8.05793L8.05793 8.59758C7.97982 8.67569 7.97982 8.80232 8.05793 8.88043L11.1773 11.9998L8.05793 15.1192C7.97982 15.1974 7.97982 15.324 8.05793 15.4021L8.59758 15.9418C8.67569 16.0199 8.80232 16.0199 8.88043 15.9418L11.9998 12.8223L15.1192 15.9418C15.1974 16.0199 15.324 16.0199 15.4021 15.9418L15.9418 15.4021C16.0199 15.324 16.0199 15.1974 15.9418 15.1192L12.8223 11.9998L15.9418 8.88043Z' fill='white'/>
        </SvgIcon>
    )
}

export default DeclineButtonIcon
